<div [formGroup]="formGroup">
  <table class="tsl-table document-list" *ngIf="requiredDocumentsFormArray?.controls.length>0">
    <thead>
      <tr class="tsl-header-row">
        <th class="tsl-header-cell" i18n="@@Type" t="Type">Type</th>
        <th class="tsl-header-cell" i18n="@@Attachment" t="Attachment">Attachment</th>
        <th class="tsl-header-cell" i18n="@@f0e56bb50e6ed6836e87d78d254177da229a07d1" t="f0e56bb50e6ed6836e87d78d254177da229a07d1">Effective Date</th>
        <th class="tsl-header-cell" i18n="@@41d055ec9cef3afb116c3118c2244ee66c895fbb" t="41d055ec9cef3afb116c3118c2244ee66c895fbb">Expiration Date</th>
      </tr>
    </thead>
    <tbody>
      <tr class="tsl-row" formArrayName="Documents"
        *ngFor="let item of requiredDocumentsFormArray?.controls; let i = index;">
        <ng-container [formGroupName]="i">
          <td class="tsl-cell"> {{item.get('DocumentType').value}} </td>
          <td class="tsl-cell">
            <div *ngIf="item.get('Attachments')?.value?.length > 0; else addFile">
              <span *ngFor="let doc of item.get('Attachments')?.value">
                <ng-container *ngIf="doc">
                  <tsl-label class="break-all">
                    {{ doc.FileName }}
                  </tsl-label>
                  <button type="button" (click)="downloadDocument(doc)" tsl-icon-button>
                    <tsl-icon>file_download</tsl-icon>
                  </button>
                  <button type="button" (click)="removeFile(i)" tsl-icon-button>
                    <tsl-icon>delete</tsl-icon>
                  </button>
                </ng-container>
              </span>
            </div>
            <ng-template #addFile>
              <tsl-file-drop [inputText]="translate.get('choose a file')" [hintText]="translate.get('Drag and Drop a File or ')" multiple="false" (fileChange)="onFileAdd(i,$event)" formControlName="Attachments">
              </tsl-file-drop>
              <tsl-error *ngIf="!item.get('Attachments')?.valid" class="text-left"
                i18n="@@PleaseUploadADocument" t="PleaseUploadADocument">
                Please upload a document
              </tsl-error>
            </ng-template>
          </td>
          <td class="tsl-cell">
            <tsl-form-field class="w-100">
              <tsl-datepicker singleSelection required shape="round" formControlName="EffectiveDate" [selectYear]="true" [readonly]="true">
              </tsl-datepicker>
              <tsl-error *ngIf="!item.get('EffectiveDate')?.valid" class="text-left"
                i18n="@@d258b1d065478feabe75fff88e9d152397ea486e" t="d258b1d065478feabe75fff88e9d152397ea486e">
                Required
              </tsl-error>
            </tsl-form-field>
          </td>
          <td class="tsl-cell">
            <tsl-form-field class="w-100">
              <tsl-datepicker singleSelection required shape="round" formControlName="ExpiryDate" [selectYear]="true" [readonly]="true">
              </tsl-datepicker>
              <tsl-error *ngIf="!item.get('ExpiryDate')?.valid" class="text-left"
                i18n="@@d258b1d065478feabe75fff88e9d152397ea486e" t="d258b1d065478feabe75fff88e9d152397ea486e">
                Required
              </tsl-error>
            </tsl-form-field>
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
</div>
